import {
  doc,
  getDoc,
  getDocs,
  collection,
  query,
  limit,
  updateDoc,
  orderBy,
  startAfter,
  getCountFromServer,
  where,
  documentId,
} from "firebase/firestore";
import { db } from "config/firebase";

const getDocument = (id) => {
  return doc(db, "predictions", id);
};

export const getData = async (reference) => {
  if (reference) {
    const docSnap = await getDoc(reference);
    return docSnap.exists ? { id: docSnap?.id, ...docSnap.data() } : null;
  }
  return null;
};

export const getPredictions = async (last, filters = {}) => {
  const orderByField = filters?.order?.orderBy || "createdAt";
  const orderDirection = filters?.order?.direction || "desc";

  try {
    // Build the base query
    let q = query(
      collection(db, "predictions"),
      orderBy(orderByField, orderDirection),
      ...(last ? [startAfter(last)] : []),
      limit(10),
    );

    // Conditionally add filter categories
    if (!!filters.categories?.length) {
      q = query(
        q,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    // Conditionally add filter predictorId
    if (!!filters.predictorId) {
      q = query(q, where("predictor.id", "==", filters.predictorId));
    }

    // Conditionally add filter finished
    if (!!filters.finished) {
      q = query(q, where("type", "==", "finished"));
    }

    const documentSnapshots = await getDocs(q);

    // Get the last visible document
    const lastVisible =
      documentSnapshots.docs[documentSnapshots.docs.length - 1];

    const predictions = documentSnapshots.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    // Build the query for the total count
    let queryCount = query(collection(db, "predictions"));

    if (!!filters.categories?.length) {
      queryCount = query(
        queryCount,
        where("categories", "array-contains-any", filters.categories),
      );
    }

    if (!!filters.predictorId) {
      queryCount = query(
        queryCount,
        where("predictor.id", "==", filters.predictorId),
      );
    }

    if (!!filters.finished) {
      queryCount = query(queryCount, where("type", "==", "finished"));
    }

    const countSnapshot = await getCountFromServer(queryCount);
    const totalPredictionsCount = countSnapshot.data().count;

    // Return predictions, last document, and total count of predictions
    return { predictions, last: lastVisible, totalPredictionsCount };
  } catch (error) {
    console.error(`Error while getting predictions: ${error}`);
    return error;
  }
};

export const getPredictionById = async (id) => {
  const docRef = getDocument(id);
  const docSnap = await getDoc(docRef);
  const prediction = docSnap.data();
  return docSnap.exists
    ? { id: docSnap.id, ...prediction, category: [], reviewers: [] }
    : null;
};

export const updatePredictions = async (id, data) => {
  try {
    await updateDoc(getDocument(id), data);
  } catch (e) {
    console.error(`Error while updating prediction ${e}`);
    return false;
  }
};

export const getPredictionsByIds = async (ids) => {
  const q = query(
    collection(db, "predictions"),
    where(documentId(), "in", ids),
  );
  const querySnapshot = await getDocs(q);
  const predictions = querySnapshot.docs.map((doc) => {
    return { ...doc.data(), id: doc.id };
  });
  return predictions;
};
